import './css/menu.css';

import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import Logo from "./Logo";


export default class Header extends Component {

    state = { visible: false }

    toggleVisibility = () => this.setState({ visible: !this.state.visible })
    hide = () => this.setState({ visible: false })

    render() {
        const { visible } = this.state
        return (
            <header>
                <div id="headercontainer">
                <Logo />

                <div className="hamburger-wrapper"  onClick={this.toggleVisibility}>
                    <button className={!visible ? "hamburger" : "hamburger hamburger--closed"}></button>	  
                </div>

                </div>

                <nav id="menu" className={!visible ? null : "visible"}>
                    <Link
                        to='/'
                        onClick={this.hide}>Mapa</Link>

                    <Link
                        to='/info'
                        onClick={this.hide}>Info</Link>

                    <Link
                        to='/form'
                        onClick={this.hide}>Agrega</Link>
                </nav>
            </header>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Header.js